.navigation-wrapper {
    position: relative;
}

/*
.keen-slider {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
*/

.keen-slider__slide {
  display: flex;
  align-items: center;
  justify-content: center;
  /*
  min-width: 100% !important;
  max-width: 100% !important;
  */
}

.arrow {
    width: 30px;
    height: 30px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    fill: #006699;
    cursor: pointer;
  }
  
  .arrow--left {
    left: 5px;
  }
  
  .arrow--right {
    left: auto;
    right: 5px;
  }
  
  .arrow--disabled {
    /* fill: rgba(255, 255, 255, 0.5); */
    display: none;
  }